import { useRouter } from 'next/router'
import { useCallback } from 'react'

interface ReturnType {
  onContinueActivity: (activityPath: string) => void
}

export default function useActivityNavigation(locale: string | undefined): ReturnType {
  const router = useRouter()

  const onContinueActivity = useCallback(
    (activityPath: string): void => {
      router.push(activityPath, activityPath, { locale })
    },
    [locale, router],
  )

  return {
    onContinueActivity,
  }
}
